module.exports = "pegasus/assets/themelp1/large/2.png";